module.exports = __webpack_public_path__ + "static/acton_video-ed8baccd27397e407df56b3539f7d99d.png";